export enum MatchType {
  /** Base match type (navmesh, walls, ants/towers with default behaviour). Others derive from this. */
  base = 'base',
  trenchRun = 'trenchRun',
  captureMode = 'captureMode'
  // TODO: Should always have been here, no?...
  // terraforming = 'terraforming'
}

export type MatchTypeKey = keyof typeof MatchType;

export const isMatchType = (type: string): type is MatchType => Object.values(MatchType).includes(type as MatchType);
